export const themes = {
    dark: {
        bg: "#0b0f14",
        panel: "#0f1720",
        border: "rgba(255,255,255,0.10)",
        text: "rgba(255,255,255,0.92)",
        muted: "rgba(255,255,255,0.65)",
        mutedText: "rgba(255,255,255,0.65)",
        bubbleUser: "#1b3a57",
        bubbleBot: "#141c26",
        inputBg: "#0f1720",
        buttonBg: "#2b7fff",
        buttonText: "#ffffff",
        cardBg: "#1f1f1f",
        messageBg: "rgba(255, 255, 255, 0.05)",
    },
    light: {
        bg: "#f6f7fb",
        panel: "#ffffff",
        border: "rgba(0,0,0,0.10)",
        text: "rgba(0,0,0,0.88)",
        muted: "rgba(0,0,0,0.60)",
        mutedText: "rgba(0,0,0,0.60)",
        bubbleUser: "#dbeafe",
        bubbleBot: "#f1f5f9",
        inputBg: "#ffffff",
        buttonBg: "#1f6feb",
        buttonText: "#ffffff",
        cardBg: "#ffffff",
        messageBg: "rgba(0, 0, 0, 0.05)",
    },
};

export const createStyles = (t) => {
    const HEADER_H = 64;
    const INPUT_H = 66;

    return {
        page: {
            height: "100%",
            width: "100%",
            background: t.bg,
            color: t.text,
            overflowX: "hidden",
        },

        container: {
            position: "fixed",
            left: 0,
            right: 0,
            top: 0,

            height: "var(--vvh)",
            transform: "translateY(var(--vvt))",

            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            background: t.bg,
            color: t.text,
            overflow: "hidden",
        },


        header: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 20,
            padding: "12px 12px",
            paddingTop: "calc(12px + env(safe-area-inset-top))",
            background: t.panel,
            borderBottom: `1px solid ${t.border}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
        },

        headerLeft: { display: "flex", flexDirection: "column", gap: 2, minWidth: 0 },
        title: {
            fontSize: 16,
            fontWeight: 800,
            lineHeight: 1.2,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: t.text,
        },
        subtitle: {
            fontSize: 13,
            color: t.muted,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },

        headerRight: { display: "flex", alignItems: "center", gap: 8 },

        smallBtn: {
            padding: "8px 10px",
            borderRadius: 12,
            border: `1px solid ${t.border}`,
            background: "transparent",
            color: t.text,
            cursor: "pointer",
            fontSize: 13,
        },

        chatBox: {
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,

            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
            overscrollBehavior: "contain",

            display: "flex",
            flexDirection: "column",
            gap: 10,

            padding: "14px 12px",
            paddingTop: `calc(14px + ${HEADER_H}px + env(safe-area-inset-top))`,
            paddingBottom: `calc(14px + ${INPUT_H}px + env(safe-area-inset-bottom))`,
        },

        message: {
            maxWidth: "86%",
            padding: "10px 12px",
            borderRadius: 14,
            fontSize: 15,
            lineHeight: 1.35,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            border: `1px solid ${t.border}`,
        },

        inputRow: {
            position: "fixed",
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 20,
            display: "flex",
            gap: 10,
            padding: "10px 12px",
            paddingBottom: "calc(10px + env(safe-area-inset-bottom))",
            background: t.panel,
            borderTop: `1px solid ${t.border}`,
        },

        input: {
            flex: 1,
            padding: "10px 12px",
            fontSize: 16, // ВАЖЛИВО: прибирає iOS auto-zoom і “зламаний масштаб”
            border: `1px solid ${t.border}`,
            borderRadius: 14,
            background: t.inputBg,
            color: t.text,
            outline: "none",
        },

        button: {
            padding: "10px 14px",
            fontSize: 14,
            cursor: "pointer",
            borderRadius: 14,
            background: t.buttonBg,
            color: t.buttonText,
            border: "none",
            fontWeight: 800,
        },

        disabledButton: {
            opacity: 0.55,
            cursor: "not-allowed",
        },
    };
};

